import {BaseFormModel} from './base-form-model';

export class UserSearchResult extends BaseFormModel<UserSearchResult> {
    id: number;
    name: string;
    email: string;
    averageRating: number;
}
